/**
 * Persists “use main-menu replica in beta/mobile shell” for Safari across layout remounts
 * (e.g. DynamicLayout portal swap, bfcache) so navigation cannot fall back to `app-beta-menu`.
 */
export const SAFARI_USE_MAIN_MENU_SESSION_KEY = 'clarichat:safariUseMainMenuReplica';

export function isSessionMarkedSafariMainMenu(): boolean {
  try {
    return typeof sessionStorage !== 'undefined' && sessionStorage.getItem(SAFARI_USE_MAIN_MENU_SESSION_KEY) === '1';
  } catch {
    return false;
  }
}

export function markSessionSafariMainMenu(): void {
  try {
    sessionStorage?.setItem(SAFARI_USE_MAIN_MENU_SESSION_KEY, '1');
  } catch {
    /* private mode / quota */
  }
}

/**
 * True WebKit Safari (not Chrome, Edge, Firefox iOS, etc.), plus common Safari-only signals
 * that still fail strict UA checks on some navigations / iOS modes.
 */
export function detectDesktopSafariUserAgent(): boolean {
  if (typeof navigator === 'undefined') {
    return false;
  }
  const userAgent = navigator.userAgent || '';
  const strict =
    /Safari/i.test(userAgent) &&
    !/Chrome|Chromium|CriOS|Edg|OPR|FxiOS/i.test(userAgent);
  if (strict) {
    return true;
  }
  if (typeof window !== 'undefined' && typeof (window as { safari?: unknown }).safari !== 'undefined') {
    return true;
  }
  const vendor = navigator.vendor || '';
  if (vendor.includes('Apple') && /Safari/i.test(userAgent) && !/CriOS|FxiOS|EdgiOS|OPiOS/i.test(userAgent)) {
    return true;
  }
  return false;
}
